/*
 * Hover zoom for the main product image.
 *
 * Markup contract (see snippets/product-thumbnail.liquid):
 *   <div class="product__media" data-hover-zoom="true" data-zoom-level="2">
 *     <img ...>
 *   </div>
 *
 * The image scales in place and follows the cursor (inner zoom). Zoom only
 * activates on real pointer devices (mouse) at the desktop breakpoint, and
 * only for the currently selected / visible main image so non-active gallery
 * images are left untouched.
 */
(() => {
  const HOVER_CAPABLE = window.matchMedia('(hover: hover) and (pointer: fine)');
  // Matches the theme's "desktop" breakpoint used by product__media-toggle--disabled-on-desktop.
  const DESKTOP = window.matchMedia('(min-width: 576px)');

  // Only the selected main image should zoom: the featured item (.active) in
  // stacked galleries, or the current slide (.swiper-slide-active) in sliders.
  function isSelectedMainMedia(media) {
    const item = media.closest('.product__media-item');
    if (!item) return true;
    return item.classList.contains('active') || item.classList.contains('swiper-slide-active');
  }

  function bind(media) {
    if (media.dataset.hoverZoomBound === 'true') return;
    const img = media.querySelector('img');
    if (!img) return;
    media.dataset.hoverZoomBound = 'true';

    const level = parseFloat(media.dataset.zoomLevel) || 2;

    const canZoom = () => HOVER_CAPABLE.matches && DESKTOP.matches && isSelectedMainMedia(media);

    const setOrigin = (event) => {
      const rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      img.style.transformOrigin = `${x}% ${y}%`;
    };

    const reset = () => {
      if (media.classList.contains('is-zoomed')) {
        media.classList.remove('is-zoomed');
        img.style.transform = '';
        img.style.transformOrigin = '';
      }
    };

    media.addEventListener('mousemove', (event) => {
      if (!canZoom()) {
        reset();
        return;
      }
      if (!media.classList.contains('is-zoomed')) {
        media.classList.add('is-zoomed');
        img.style.transform = `scale(${level})`;
      }
      setOrigin(event);
    });

    media.addEventListener('mouseleave', reset);
  }

  function init(root) {
    (root || document).querySelectorAll('.product__media[data-hover-zoom]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
